import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ActualCuttingService } from "../../../services/index";
import { cuttingDcPrint } from "../cuttingStore/cuttingDcPrint";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./storeFusing.html"
})
export class storeFusingComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  designnoList = [];
  gridOptions: any;
  dataList = [];
  selected = [];
  data = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  storeFusingDCStatusList = ["YES", "NO"];
  collarDcStatusList = ["YES", "NO"];
  fusingStoreList = ["Return From Fusing"];
  collarStoreList = ["Return From Collar"];
  filter = {
    wo_no: "",
    fusing_dc_status: "NO",
    collar_dc_status: "NO",
    fusing_rt_store: "",
    collar_rt_store: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_id",
    orderDir: "desc"
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("detailsTemplate") detailsTemplate;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("pageTemplate") pageTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private acService: ActualCuttingService,
    private modalService: BsModalService,
    public toasterService: ToasterService,
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    if (this.menu.param == 'store_to_collar') {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center"
        },
        {
          name: "Date",
          prop: "collar_issue_date",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100
        },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80
        },
        {
          name: "Issued Part ",
          prop: "collar_part",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120
        },
        {
          name: "Status",
          prop: "act_status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          headerClass: "text-center",
          cellClass: "text-center",
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate
        }

      ];
    } else {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center"
        },
        {
          name: "Date",
          prop: "fusing_issue_date",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100
        },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80
        },
        {
          name: "Issue Parts",
          prop: "issuepart_1",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 220,
          maxWidth: 220,
          width: 220
        },
        {
          name: "Status",
          prop: "act_status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          headerClass: "text-center",
          cellClass: "text-center",
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate
        }
      ];
    }
    if (this.menu.param == 'store_to_collar') {
      if (this.filter.collar_dc_status == "NO") {
        let select = {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: false,
          checkboxable: true,
          width: 30,
        };
        this.columns.splice(0, 0, select);
      }
      else if (this.filter.collar_rt_store == "Return From Collar" && this.filter.collar_dc_status == "YES") {
        let collar_store = {
          name: "Return Status",
          prop: "return_status",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150
        }
        this.columns.splice(5, 0, collar_store)
      }
      else if (this.filter.collar_dc_status == "YES") {

        let collar_dcprint = {
          name: "COLLAR DC Print",
          prop: "collar_dcprint",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          cellClass: "text-center",
          sortable: false,
          cellTemplate: this.detailsTemplate,
        };
        this.columns.splice(7, 0, collar_dcprint)

        let collar_dc_no = {
          name: "COLLAR.DC.NO",
          prop: "collar_dc_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        }
        this.columns.splice(1, 0, collar_dc_no)
      }
      else {
        let column = this.columns.filter(function (obj) {
          return obj.prop !== "selected";
        });
        this.columns = column;
      }
    } else {
      if (this.filter.fusing_dc_status == "NO") {
        let select = {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: false,
          checkboxable: true,
          width: 30,
        };
        this.columns.splice(0, 0, select);
      }
      else if (this.filter.fusing_rt_store == "Return From Fusing" && this.filter.fusing_dc_status == "YES") {

        let fusing_store = {
          name: "Return Status",
          prop: "return_status",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150
        }
        this.columns.splice(5, 0, fusing_store)
      }
      else if (this.filter.fusing_dc_status == "YES") {

        let fusing_dcprint = {
          name: "FUSING DC Print",
          prop: "fusing_dcprint",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
          cellClass: "text-center",
          sortable: false,
          cellTemplate: this.detailsTemplate,
        };
        this.columns.splice(7, 0, fusing_dcprint)

        let fusing_dc_no = {
          name: "FUSING.DC.NO",
          prop: "fusing_dc_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        }
        this.columns.splice(1, 0, fusing_dc_no)
      } 
      else {
        let column = this.columns.filter(function (obj) {
          return obj.prop !== "selected";
        });
        this.columns = column;
      }
    }
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  clearFilter(): void {
    this.filter.wo_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getColumns();
    // this.getOrderList();
  }
  onSelect({ selected }) {
    this.selected = [];
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  addEditPO(mode: string, row: any): void {
    // console.log(row,"check")
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (this.menu.param == 'store_to_collar') {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "ADD STORE TO COLLAR",
            title: "ADD STORE TO COLLAR",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "STORE TO COLLAR"
          }
        };
      } else if (mode == "Edit") {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "EDIT STORE TO COLLAR",
            title: "EDIT STORE TO COLLAR",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "EDIT STORE TO COLLAR"
          }
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "VIEW STORE TO COLLAR",
            title: "VIEW STORE TO COLLAR",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            param: this.menu.param,
            name: "VIEW STORE TO COLLAR"
          }
        };
      }
    } else {
      if (mode == "Add") {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "ADD STORE FUSING",
            title: "ADD STORE FUSING",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "ADD STORE FUSING"
          }
        };
      } else if (mode == "Edit") {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "EDIT STORE FUSING",
            title: "EDIT STORE FUSING",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "EDIT STORE FUSING"
          }
        };
      } else {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "VIEW STORE FUSING",
            title: "VIEW STORE FUSING",
            tabParent: "PURCHASE",
            mode: mode,
            data: row,
            name: "VIEW STORE FUSING"
          }
        };
      }
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  bsModalRef: BsModalRef;

  getOrderList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_no: this.filter.wo_no,
      fusing_status: this.filter.fusing_dc_status,
      collar_status: this.filter.collar_dc_status,
      fusing_return_status: this.filter.fusing_rt_store,
      collar_return_status: this.filter.collar_rt_store,
    };
    params['flag'] = '';
    if (this.menu.param == 'store_to_collar') {
      params['flag'] = this.menu.param;
    }
    let that = this;
    this.isLoadMask = this.acService
      .getStoreFusingList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  onSubmitMergeDC() {
    if (this.selected.length > 0) {
      let obj = {
        ac_id: "",
        fusing_dc_status: "",
      };
      this.selected.forEach((el) => {
        obj = {
          ac_id: el.ac_id,
          fusing_dc_status: "YES",
        };
        this.data.push(obj);
      });
      this.approveFusingDc();
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
  onSubmitMergeCollarDC() {
    if (this.selected.length > 0) {
      let obj = {
        ac_id: "",
        collar_dc_status: "",
      };
      this.selected.forEach((el) => {
        obj = {
          ac_id: el.ac_id,
          collar_dc_status: "YES",
        };
        this.data.push(obj);
      });
      this.approveCollarDc();
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
  approveCollarDc() {
    let that = this;
    swal({
      title: "Are you sure to Approve these COLLAR DC.NO?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        let params = {
          selectedList: JSON.stringify(that.data),
        };
        that.isLoadMask = that.acService
          .approveCollarDc(params)
          .then((res: any) => {
            if (res.success) {
              swal(
                "COLLAR DC Approved Successfully and  COLLAR DC No " +
                res.collar_dc_no +
                " was generated"
              );
              that.data = [];
            }
            if (res.success) {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          });
      },
      function (dismiss) { }
    );
  }
  approveFusingDc() {
    let that = this;
    swal({
      title: "Are you sure to Approve these FUSING DC.NO?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    }).then(
      function () {
        let params = {
          selectedList: JSON.stringify(that.data),
        };
        that.isLoadMask = that.acService
          .approveFusingDc(params)
          .then((res: any) => {
            if (res.success) {
              swal(
                "FUSING DC Approved Successfully and  FUSING DC No " +
                res.fusing_dc_no +
                " was generated"
              );
              that.data = [];
            }
            if (res.success) {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          });
      },
      function (dismiss) { }
    );
  }
  print(row) {
    // console.log(row,"chek from print")
    row.page_type = this.menu.open_type
    this.bsModalRef = this.modalService.show(cuttingDcPrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/storeFusing/storeFusing.ts